// extracted by mini-css-extract-plugin
module.exports = {"actions":"DocumentsActionsCell_actions_JbRuR","error":"DocumentsActionsCell_error_91dp0"};